import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Glossary } from '@xing-com/crate-career-hub-common';
import type { ReducedLettersType } from '@xing-com/crate-career-hub-common';
import type { CareerHubGlossaryCollectionFragment } from '@xing-com/crate-career-hub-glossary-graphql';
import { Link } from '@xing-com/crate-components-link';
import { useLocation } from '@xing-com/crate-core-router';
import { BodyCopy } from '@xing-com/typography';

import { Styled } from './article-list.styles';

export type ArticleListType = {
  articlesCollection?: (CareerHubGlossaryCollectionFragment | null)[];
  reducedLetters: ReducedLettersType;
};
export const ArticleList: React.FC<ArticleListType> = ({
  articlesCollection,
  reducedLetters,
}) => {
  const { hash } = useLocation();

  React.useEffect(() => {
    setTimeout(() => {
      // hash length should be always '#' + letter, if it is longer
      // or shorter than 2 it should not scroll at all
      const selectedLetter = hash?.length === 2 && hash[1];
      const selectedLetterElement = document.getElementById(
        `#${selectedLetter}`
      );
      selectedLetterElement?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }, [hash]);

  return (
    <>
      <Styled.Headline size="xxlarge">
        <FormattedMessage id="CAREER_HUB_GLOSSARY_TITLE" />
      </Styled.Headline>
      <Glossary {...{ reducedLetters }} openInSameTab />
      <Styled.List>
        {articlesCollection?.map((articleCollection) => (
          <Styled.ListItem key={articleCollection?.letter}>
            <Styled.Hero
              data-qa="glossary-content-letter"
              id={`#${articleCollection?.letter}`}
              size="small"
              sizeConfined="large"
            >
              {articleCollection?.letter}
            </Styled.Hero>
            <Styled.Divider />
            <Styled.Articles>
              {articleCollection?.articles?.map((article) => (
                <BodyCopy key={article?.title}>
                  <Link href={article?.url}>{article?.title}</Link>
                </BodyCopy>
              ))}
            </Styled.Articles>
          </Styled.ListItem>
        ))}
      </Styled.List>
    </>
  );
};
